export default __webpack_public_path__ + "static/media/trello-logo-white.225b2939.png";